import React from "react";

import SmartImage from "../../../components/SmartImage";
import { formatDistance, formatPriceLabel } from "../../search/suppliersMappers";

export const StarIcon = () => (
  <svg className="home-supplier-star" viewBox="0 0 20 20" aria-hidden="true">
    <path d="m10 2.6 2.32 4.7 5.18.76-3.75 3.65.89 5.16L10 14.44l-4.64 2.43.89-5.16L2.5 8.06l5.18-.76L10 2.6Z" />
  </svg>
);

export const PinIcon = () => (
  <svg className="home-supplier-pin" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M8 1.7a4.45 4.45 0 0 0-4.45 4.45c0 3.3 4.45 8.15 4.45 8.15s4.45-4.85 4.45-8.15A4.45 4.45 0 0 0 8 1.7Zm0 6.05a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z" />
  </svg>
);

const SupplierListCard = ({
  supplier,
  saved,
  pending,
  canSave,
  onOpen,
  onToggleSave,
  onHover,
}) => {
  const secondary =
    supplier.distanceKm !== null
      ? formatDistance(supplier.distanceKm)
      : supplier.addressLine;

  return (
    <li
      className="home-supplier-row"
      onMouseEnter={() => onHover?.(supplier.id)}
      onMouseLeave={() => onHover?.(null)}
    >
      <button
        type="button"
        className="home-supplier-open"
        onClick={() => onOpen(supplier)}
      >
        <span className="home-supplier-logo">
          {supplier.logoUrl ? (
            <SmartImage src={supplier.logoUrl} alt="" />
          ) : (
            <span aria-hidden="true">{supplier.name.charAt(0)}</span>
          )}
          {!supplier.online && <i className="home-supplier-offline" />}
        </span>

        <span className="home-supplier-body">
          <span className="home-supplier-name">{supplier.name}</span>

          {supplier.totalRatings > 0 && (
            <span className="home-supplier-rating">
              <StarIcon />
              {supplier.rating.toFixed(1)}
              <i>({supplier.totalRatings})</i>
            </span>
          )}

          <span className="home-supplier-footer">
            {secondary && (
              <span className="home-supplier-meta">
                <PinIcon />
                <span>{secondary}</span>
              </span>
            )}

            {supplier.pricePerKg !== null && (
              <span className="home-supplier-price">
                <i>from</i>
                <b>{formatPriceLabel(supplier.pricePerKg, supplier.currency)}</b>
              </span>
            )}
          </span>
        </span>
      </button>

      {canSave && (
        <button
          type="button"
          className={`home-supplier-save${saved ? " is-saved" : ""}`}
          disabled={pending}
          aria-pressed={saved}
          aria-label={saved ? `Remove ${supplier.name} from saved` : `Save ${supplier.name}`}
          onClick={() => onToggleSave(supplier)}
        >
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <path d="M5 2.5h10a1 1 0 0 1 1 1v14l-6-3.6-6 3.6v-14a1 1 0 0 1 1-1Z" />
          </svg>
        </button>
      )}
    </li>
  );
};

export default React.memo(SupplierListCard);
